import { createAction, props } from '@ngrx/store';
import { IAdditionalSettings, IField } from '@shared/model/basic-data';

export enum AdditionalSettingsActionTypes {
  GET_ADDITIONAL_SETTINGS = '[Basic Data] Get Additional Settings',
  GET_ADDITIONAL_SETTINGS_SUCCESS = '[Basic Data] Get Additional Settings Success',
  GET_ADDITIONAL_SETTINGS_FAILURE = '[Basic Data] Get Additional Settings Failure',

  UPDATE_ADDITIONAL_SETTINGS = '[Basic Data] Update Additional Settings',
  UPDATE_ADDITIONAL_SETTINGS_SUCCESS = '[Basic Data] Update Additional Settings Success',
  UPDATE_ADDITIONAL_SETTINGS_FAILURE = '[Basic Data] Update Additional Settings Failure',
}

export const getAdditionalSettings = createAction(
  AdditionalSettingsActionTypes.GET_ADDITIONAL_SETTINGS,
  props<{ id: number }>(),
);

export const getAdditionalSettingsSuccess = createAction(
  AdditionalSettingsActionTypes.GET_ADDITIONAL_SETTINGS_SUCCESS,
  props<{ additionalSettings: IAdditionalSettings }>(),
);

export const getAdditionalSettingsFailure = createAction(AdditionalSettingsActionTypes.GET_ADDITIONAL_SETTINGS_FAILURE);

export const updateAdditionalSettings = createAction(
  AdditionalSettingsActionTypes.UPDATE_ADDITIONAL_SETTINGS,
  props<{ id: number; data: IField }>(),
);

export const updateAdditionalSettingsSuccess = createAction(
  AdditionalSettingsActionTypes.UPDATE_ADDITIONAL_SETTINGS_SUCCESS,
  props<{ data: IField }>(),
);

export const updateAdditionalSettingsFailure = createAction(
  AdditionalSettingsActionTypes.UPDATE_ADDITIONAL_SETTINGS_FAILURE,
);
